/**
 * Input capabilities a game may require (architecture §11). Declared by a module, checked by
 * the platform before launch. CLAP, RHYTHM, TARGET_WORD and LOUDNESS are declared for the
 * contract but have no detector in the MVP.
 */
export type InputCapability =
  | 'PLAYER_PRESENCE'
  | 'BODY_ZONE'
  | 'JUMP'
  | 'CROUCH'
  | 'HANDS_RAISED'
  | 'STILLNESS'
  | 'SEQUENCE'
  | 'CLAP'
  | 'RHYTHM'
  | 'TARGET_WORD'
  | 'LOUDNESS';

export const INPUT_CAPABILITIES: readonly InputCapability[] = [
  'PLAYER_PRESENCE',
  'BODY_ZONE',
  'JUMP',
  'CROUCH',
  'HANDS_RAISED',
  'STILLNESS',
  'SEQUENCE',
  'CLAP',
  'RHYTHM',
  'TARGET_WORD',
  'LOUDNESS',
] as const;

/** Capabilities with a detector or keyboard adapter planned for the MVP. */
export const MVP_INPUT_CAPABILITIES: readonly InputCapability[] = [
  'PLAYER_PRESENCE',
  'BODY_ZONE',
  'JUMP',
  'CROUCH',
  'HANDS_RAISED',
  'STILLNESS',
] as const;
